module.exports = __webpack_public_path__ + "assets/img/bdf9513fd3a3e746ff953c8d9be49d1e.png";